import { Icon } from '@chakra-ui/react';
import { BsArrowUpShort } from 'react-icons/bs';

const ArrowUpIcon = (props) => {
  return (
    <Icon as={BsArrowUpShort} {...props} />
  );
}

export default ArrowUpIcon;